import { baseMutations, baseActions } from '../functions'

export default {
  namespaced: true,
  state: {
    // Info
    items: [],
    title: 'Funcionários',
    name: 'Funcionários',
    loading: true,

    // Menu
    menu: {
      title: 'Funcionários',
      icon: { key: 'funcionarios', custom: true }
    },

    // Routes - Components actions
    actions: {
      // Main Action
      component: 'Cards.FuncionarioProfile',
      props: { module: 'users', modelKey: 'profile' }
    },

    get: {
      urn: 'Employees',
      response: ''
    },

    // Models
    models: {
      profile: [
        { key: 'name', label: 'Nome', slot: 'Nome' }
      ]
    }
  },

  // Mantém mutations/actions base
  mutations: Object.assign({}, baseMutations),
  actions: Object.assign({}, baseActions)
}
